import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import banner from "../otherImages/signUpImg.png";
import { Formik, Form, Field } from "formik";

const SignInLayer = () => {
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState("");

  const handleLogin = async (values, { setSubmitting }) => {
    try {
      setLoginError("");

      const response = await fetch("https://clearshine.koderspedia.online/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      });

      const result = await response.json();

      if (response.ok && result?.success) {
        localStorage.setItem("token", result.token);
        localStorage.setItem("user", JSON.stringify(result.user));
        localStorage.setItem("role", result.user?.role?.toLowerCase() || "admin");

        navigate("/bookings");
      } else {
        setLoginError(result?.message || "Invalid email or password");
      }
    } catch (error) {
      console.error("Login API Error:", error);
      setLoginError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="auth bg-base d-flex">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img
            className="h-100vh w-100"
            src={banner}
            alt=""
            style={{ objectFit: "cover", objectPosition: "bottom" }}
          />
        </div>
      </div>

      <div className="auth-right py-22 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px">
              <img src="assets/images/logo.png" alt="" />
            </Link>

            <h4 className="mb-12 fw-bold fs-1">Sign In</h4>

            <p className="mb-32 text-secondary-light text-lg">
              Please enter the details to login an account
            </p>
          </div>

          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            onSubmit={handleLogin}
          >
            {({ isSubmitting }) => (
              <Form>
                {loginError && (
                  <div className="alert alert-danger mb-16" role="alert">
                    {loginError}
                  </div>
                )}

                <div className="icon-field mb-16">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="mage:email" />
                  </span>

                  <Field
                    type="email"
                    name="email"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="Email"
                    required
                  />
                </div>

                <div className="icon-field mb-20">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>

                  <Field
                    type="password"
                    name="password"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="Password"
                    required
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn bg-primary py-16 w-100 radius-12 mt-32"
                >
                  {isSubmitting ? "Signing In..." : "Sign In"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;